<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="title">
<p class="bk">Mad Dog &amp; Englishman</p>
<p class="bkau">J.M. Hayes</p>
<p class="bkau1"><a class="calibre3" href="http://www.jmhayes-author.com" target="_blank">www.jmhayes-author.com</a></p>
<p class="bkpub">Poisoned Pen Press</p>
<p class="bkpub"><img alt="" class="calibre4" src="OEBPS/ppp-logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-maddog002.vue?73f02118